<template>
    <div>

        <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>设备列表</b></p>
            <p style="display:inline;float: right;line-height: 22px;">
                <el-button size="mini" round @click="openDialog">添加设备</el-button>
            </p>
        </div>

        <el-table :data="equipmentList" style="width: 100%">
            <el-table-column prop="equipmentCode" label="设备编号" width="500">
            </el-table-column>
            <el-table-column prop="equipmentName" label="设备名称" width="500">
            </el-table-column>
            <el-table-column prop="statusDes" label="设备状态" width="400">
            </el-table-column>

            <el-table-column prop="macAddress" label="mac地址" v-if="false">
            </el-table-column>
            <el-table-column prop="ipAddress" label="ip地址" v-if="false">
            </el-table-column>

            <el-table-column fixed="right" label="操作">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="text" size="small"
                        style="color:#6f5499">编辑</el-button>
                    <!-- <el-button @click="changeClick(scope.row)" type="text" size="small"
                        style="color:#6f5499">更改状态</el-button>
                    <el-button @click="printClick(scope.row)" type="text" size="small"
                        style="color:#6f5499">打印条形码</el-button> -->
                    <el-button @click="deleteClick(scope.row)" type="text" size="small"
                        style="color:orange">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog title="设备详情" :visible.sync="dialogFormVisible" width="25%">
            <el-form :model="form" :rules="rules" class="demo-ruleForm" ref="ruleForm">
                <el-form-item label="设备编号" :label-width="formLabelWidth" prop="equipmentCode">
                    <el-input v-model="form.equipmentCode" autocomplete="off" style="width:300px"></el-input>
                </el-form-item>
                <el-form-item label="设备名称" :label-width="formLabelWidth" prop="equipmentName">
                    <el-input v-model="form.equipmentName" autocomplete="off" style="width:300px"></el-input>
                </el-form-item>

                <el-form-item label="mac地址" :label-width="formLabelWidth">
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;</span><el-input v-model="form.macAddress" autocomplete="off"
                        style="width:300px"></el-input>
                </el-form-item>
                <el-form-item label="ip地址" :label-width="formLabelWidth">
                    &nbsp;<el-input v-model="form.ipAddress" autocomplete="off" style="width:300px"></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addEquipment('ruleForm')">保 存</el-button>
            </div>
        </el-dialog>

        <!-- <el-dialog title="设备状态" :visible.sync="statusDialogVisible" width="50%">
            <el-tag type="danger">当前选择的设备编号：{{ form.equipmentCode }}</el-tag>
            <p>
                <el-radio-group v-model="form.status">
                    <el-radio :label="1">待机</el-radio>
                    <el-radio :label="2">生产</el-radio>
                    <el-radio :label="3">检修</el-radio>
                    <el-radio :label="4">暂停</el-radio>
                </el-radio-group>
            </p>

            <div slot="footer" class="dialog-footer">
                <el-button @click="statusDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="addEquipment">保 存</el-button>
            </div>
        </el-dialog> -->

        <!-- <el-dialog title="打印条形码" :visible.sync="printDialogVisible" width="50%">
            <div id="barcode-img" v-html="barcodeUrl"></div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="printDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="printBarcode(1)">打 印</el-button>
            </div>
        </el-dialog> -->
    </div>
</template>

<script>

export default {
    name: "EquipmentManage",
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),
            equipmentList: [],
            dialogFormVisible: false,
            statusDialogVisible: false,
            printDialogVisible: false,
            form: {
                id: '',
                equipmentCode: '',
                equipmentName: '',
                macAddress: '',
                ipAddress: '',
                status: ''
            },
            rules: {
                equipmentCode: [{
                    required: true, message: '请输入设备编号', trigger: 'blur'
                }],
                equipmentName: [{
                    required: true, message: '请输入设备名称', trigger: 'blur'
                }]
            },
            barcodeUrl: ''
        }

    },
    methods: {
        openDialog() {
            this.form.id=''
            
            this.form.equipmentCode = ''
            this.form.equipmentName = ''
            this.form.macAddress = ''
            this.form.ipAddress = ''
            this.dialogFormVisible = true
        },
        addEquipment(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    //alert('submit!');
                    this.$axios({
                        method: "post",
                        url: "/shiro/equipment/add",
                        data: {
                            id: this.form.id,
                            equipmentCode: this.form.equipmentCode,
                            equipmentName: this.form.equipmentName,
                            macAddress: this.form.macAddress,
                            ipAddress: this.form.ipAddress,
                            status: this.form.status,
                            companyId: this.companyId
                        },
                        headers: {
                            token: this.token
                        }
                    }).then(result => {
                        const data = result.data
                        if (data.status === 201) {
                            this.$message({
                                type: 'info',
                                message: data.msg
                            })
                        }
                        this.getAll()

                        this.$axios({
                            method: "get",
                            url: "/shiro/equipment/print?equipmentCode=" + this.form.equipmentCode,
                            headers: {
                                token: this.token
                            }
                        }).then(result => { })

                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            })

        },
        getAll() {
            this.$axios({
                method: "post",
                url: "/shiro/equipment/getAll",
                data: {
                    id: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                this.equipmentList = data.data
                for (let i in this.equipmentList) {
                    if (this.equipmentList[i].status == 1) {
                        this.equipmentList[i].statusDes = '暂停'
                    } else if (this.equipmentList[i].status == 2) {
                        this.equipmentList[i].statusDes = '加工'
                    } else {
                        this.equipmentList[i].statusDes = '故障'
                    }
                }

                if (this.dialogFormVisible) {
                    this.dialogFormVisible = false
                } else {
                    this.statusDialogVisible = false
                }

            })
        },
        handleClick(row) {
            this.form.id = row.id

            this.dialogFormVisible = true
            this.form.equipmentCode = row.equipmentCode
            this.form.equipmentName = row.equipmentName
            this.form.macAddress = row.macAddress
            this.form.ipAddress = row.ipAddress
            this.form.status = row.status
        },
        // changeClick(row) {
        //     this.form.id = row.id
        //     this.form.equipmentCode = row.equipmentCode
        //     this.form.equipmentName = row.equipmentName
        //     this.form.macAddress = row.macAddress
        //     this.form.ipAddress = row.ipAddress
        //     this.form.status = row.status
        //     //console.log(this.form.status)
        //     this.statusDialogVisible = true
        // },
        // printClick(row) {

        //     this.barcodeUrl = "<img src='/barcode/" + row.equipmentCode + ".png'>"
        //     // this.barcodeUrl="<img src='/favicon.ico' style='height: 150px;width: 150px'/>"
        //     this.printDialogVisible = true
        // },
        // printBarcode(fang) {
        //     var content = document.getElementById("barcode-img").innerHTML
        //     var sprnstr = "<!--startprint" + fang + "-->"
        //     var eprnstr = "<!--endprint" + fang + "-->"

        //     var iframe = document.createElement("IFRAME")
        //     var doc = null;
        //     iframe.setAttribute('style', 'position:absolute;width:0;height:0;left:-500px;top:-500px;')

        //     document.body.appendChild(iframe)
        //     doc = iframe.contentWindow.document
        //     doc.write(content)
        //     doc.close()
        //     iframe.contentWindow.focus()

        //     iframe.contentWindow.addEventListener('load', function () {
        //         iframe.contentWindow.print()
        //         document.body.removeChild(iframe)
        //     })
            
        // },
        deleteClick(row) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.removeEquipment(row)
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        removeEquipment(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/equipment/remove",
                data: {
                    id: row.id,
                    equipmentCode: row.equipmentCode,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                this.getAll()
            })
        }
    },
    mounted() {
        this.getAll()
    }
}
</script>